import React from "react";

import { SentinelInfoSection } from "./sentinel-info-section";

export const SentinelOnboardingPageInfoSection = () => (
    <SentinelInfoSection header="Onboarding Page">
        <div>
            <p>
        On this page you will be able to onboard your team owned pipelines to Dependency Sentinel. You can do multiple pipelines in a single onboarding.
            </p>
        </div>
    </SentinelInfoSection>
);